import React from 'react';
import { Badge } from '../ui';

/**
 * The marker on a BOM line Robbie suggested and the buyer added ("Add X" on
 * the validation step). Robbie-tone badge: the line's origin is Robbie's,
 * the decision to add it was the buyer's.
 */
export const isRobbieSuggested = (line: { origin?: unknown } | null | undefined): boolean =>
  line?.origin === 'robbie_suggestion';

export const RobbieSuggestedTag: React.FC<{ className?: string }> = ({ className = '' }) => (
  <Badge tone="robbie" title="Robbie suggested this line; you added it" className={`shrink-0 whitespace-nowrap ${className}`}>
    Robbie suggested
  </Badge>
);

export default RobbieSuggestedTag;
